module.exports = __webpack_public_path__ + "img/tree-07-g-leaves.917853dd.png";